const translation = {
  Product: "Продукт",
  "Header.productNav": "Продукт LUKKEY",
  Feature: "Особливості",
  "About Us": "Про нас",
  FAQ: "Часто задавані питання",
  "Privacy Policy": "Політика конфіденційності",
  "Help Center": "Центр допомоги",
  "Header.infoMenu": "Ще",
  "Header.appNow": "Завантажити застосунок",
  "Header.appModal.title": "Скористайтеся застосунком LUKKEY зараз",
  "Header.appModal.subtitle": "Оберіть платформу, щоб отримати офіційний мобільний застосунок LUKKEY.",
  "Header.appModal.iosTitle": "iOS App Store",
  "Header.appModal.iosDesc": "Встановіть офіційний застосунок на iPhone.",
  "Header.appModal.iosButton": "Відкрити",
  "Header.appModal.googlePlayTitle": "Google Play",
  "Header.appModal.googlePlayDesc": "Отримайте офіційний Android-застосунок у Google Play.",
  "Header.appModal.googlePlayButton": "Відкрити",
  "Header.appModal.androidTitle": "Android APK",
  "Header.appModal.androidDesc": "Завантажте останній офіційний APK напряму.",
  "Header.appModal.androidButton": "Завантажити",
  "Header.appModal.note": "Лише офіційні мобільні завантаження. Скористайтеся посиланнями вище для останньої версії.",
  "Academy": "Академія",
  "Legal": "Юридична інформація",
  "AboutUs.title": "Про LUKKEY",
  "AboutUs.lede": "LUKKEY — швейцарський бренд апаратних гаманців, присвячений найвищому стандарту безпеки для володіння цифровими активами.",
  "AboutUs.vision.closing": "Ваші ключі. Ваші активи. Ваше майбутнє.",
  "AboutUs.quote": "LUKKEY створює рівень безпеки між людьми та цифровими активами.",
  "AboutUs.block1": "LUKKEY базується у Швейцарії. Компанія зосереджена на апаратних гаманцях для безпечного самостійного зберігання активів.",
  "AboutUs.block2": "Продукти поєднують secure element, захист від втручання та повністю офлайн-архітектуру. Мета полягає в тому, щоб приватні ключі залишалися в ізольованому середовищі.",
  "AboutUs.block3": "Система розроблена без Wi‑Fi, USB і прямої мережевої залежності. Доступ за відбитком пальця, NFC-інструменти резервного копіювання та широка підтримка активів роблять її практичною для щоденного використання.",
  "AboutUs.block5": "LUKKEY дотримується відкритого та аудійованого підходу до основної прошивки й програмного забезпечення. Заяви про безпеку мають залишатися перевірюваними та підтверджуваними.",
  "HelpCenter.back": "Back to Help Center",
  "WarrantySupport.title": "Запит у підтримку",
  "WarrantySupport.intro": "Будь ласка, заповніть інформацію нижче, щоб надіслати запит у підтримку.",
  "WarrantySupport.form.name.label": "Name",
  "WarrantySupport.form.name.placeholder": "Enter your name",
  "WarrantySupport.form.email.label": "Email",
  "WarrantySupport.form.email.placeholder": "Enter your email",
  "WarrantySupport.form.issueTitle.label": "Короткий опис",
  "WarrantySupport.form.issueTitle.placeholder": "Введіть короткий опис",
  "WarrantySupport.form.warrantyType.label": "Тип запиту",
  "WarrantySupport.form.warrantyType.placeholder": "Оберіть тип запиту",
  "WarrantySupport.form.warrantyType.product": "Проблема пристрою",
  "WarrantySupport.form.warrantyType.service": "Проблема застосунку/акаунта",
  "WarrantySupport.form.warrantyType.replacement": "Інше",
  "WarrantySupport.form.feedback.label": "Feedback",
  "WarrantySupport.form.feedback.placeholder": "Опишіть проблему або запит детально",
  "WarrantySupport.form.submit": "Надіслати запит у підтримку",
  "WarrantySupport.alert.success": "Ваш запит у підтримку надіслано!",
  "WarrantySupport.alert.error": "There was an error submitting your claim.",
  "HelpCenter.title": "Центр допомоги",
  "HelpCenter.intro":
    "Ласкаво просимо до Центру допомоги LUKKEY! Якщо ви новачок у криптовалютах або вам потрібна допомога з холодним гаманцем, ви у правильному місці. Наше рішення холодного гаманця забезпечує найбезпечніший спосіб зберігання та керування цифровими активами. Нижче ви знайдете відповіді на найпоширеніші запитання та поради щодо усунення несправностей.",
  "HelpCenter.section4.title": "Потрібна додаткова допомога?",
  "HelpCenter.section4.intro":
    "Заощадьте час, розпочавши запит підтримки онлайн, і ми з’єднаємо вас із фахівцем. З міркувань безпеки офіційна підтримка ніколи не попросить вашу фразу відновлення або приватний ключ:",
  "HelpCenter.contact.hint": "Натисніть кнопку, щоб надіслати запит у підтримку, і ми зв’яжемося з вами електронною поштою.",
  "HelpCenter.cta.warranty": "Надіслати запит у підтримку",
  brandName: "LUKKEY",
  tagline: "Управляйте своїми криптовалютами як ніколи раніше",
  description:
    "Розпочніть свою подорож до фінансової свободи з нашим додатком. Захищайте свої активи за допомогою нашої передової технології холодних гаманців і керуйте своїми фінансами розумно та ефективно. Ваше фінансове благополуччя є нашою головною метою.",
  "home.seoTitle": "LUKKEY | Швейцарський апаратний гаманець для безпечного self-custody",
  "home.seoDescription": "LUKKEY — швейцарський бренд апаратних гаманців, зосереджений на безпеці cold wallet, офлайн-захисті приватних ключів, доступі за відбитком пальця та NFC-резервному копіюванні для безпечного self-custody.",
  learnMore: "Дізнатися більше",
  "Lock Your Crypto, Securely": "Надійно заблокуйте вашу криптовалюту",
  Testimonials: "Відгуки",
  Testimonial1:
    "Я використовую цей холодний гаманець уже кілька місяців, і я вражений його надійністю та функціями безпеки. Щиро рекомендую!",
  Testimonial2:
    "Цей холодний гаманець перевершив мої очікування! Його зручний інтерфейс та найвища безпека роблять його необхідним інструментом для всіх, хто серйозно ставиться до криптовалют.",
  Testimonial3:
    "Я пробував кілька холодних гаманців, але цей виділяється. Його елегантний дизайн і передові функції роблять управління моїми криптоактивами легким.",
  "John Doe": "Джон Доу",
  "Cryptocurrency Enthusiast": "Ентузіаст криптовалют",
  "Jane Smith": "Джейн Сміт",
  "Crypto Security Advocate": "Адвокат безпеки криптовалют",
  "Alex Johnson": "Алекс Джонсон",
  "Investment Analyst": "Інвестиційний аналітик",
  "Touchscreen Interface": "Інтерфейс з сенсорним екраном",
  "Experience effortless crypto management with our intuitive touchscreen interface, designed for quick and easy navigation through your digital assets, enabling swift transactions and secure management at your fingertips.":
    "Відчуйте легкість управління криптовалютами з нашим інтуїтивно зрозумілим сенсорним екраном, розробленим для швидкої та зручної навігації через ваші цифрові активи, що дозволяє здійснювати швидкі транзакції та безпечне управління.",
  "Bluetooth Connectivity": "Підключення Bluetooth",
  "Wireless syncing with your devices for real-time updates.":
    "Бездротова синхронізація з вашими пристроями для оновлень в реальному часі.",
  "Airtag Tracking": "Відстеження Airtag",
  "Track your wallet easily with built-in Airtag.":
    "Легко відстежуйте свій гаманець завдяки вбудованому Airtag.",
  "Secure Chip Technology": "Технологія захищеного чіпа",
  "Equipped with an advanced security chip, ensuring robust protection for your valuable digital assets against unauthorized access and cyber threats.":
    "Оснащений передовим чіпом безпеки, що забезпечує надійний захист ваших цінних цифрових активів від несанкціонованого доступу та кіберзагроз.",
  AboutUsDescription1:
    "У LUKKEY ми прагнемо надавати високоякісні рішення для безпечного керування вашими криптовалютними активами.",
  AboutUsDescription2:
    "Наш головний офіс знаходиться в Цузі, Швейцарія. З командою досвідчених фахівців ми прагнемо до інновацій і адаптації до постійно змінюваного ринку цифрових валют.",
  BlockchainNetworksSupported: "Підтримувані блокчейн-мережі",
  CryptocurrenciesSupported: "Підтримка понад 6 000 криптовалют",
  Years: "Роки",
  ExpertiseInSecurity: "експертиза в безпеці",
  FrequentlyAskedQuestions: "Часто задавані питання",
  WhatIsColdWallet: "Що таке холодний гаманець?",
  ColdWalletDescription:
    "Холодний гаманець - це тип криптовалютного гаманця, який зберігає ваші цифрові активи офлайн, що робить їх менш вразливими до зломів та інших онлайн-загроз. На відміну від гарячих гаманців, які підключені до Інтернету і зручні для частих транзакцій, холодні гаманці найкраще підходять для довгострокового зберігання, оскільки вони забезпечують посилене безпеки.",
  HowToSetUpColdWallet: "Як налаштувати свій холодний гаманець?",
  ColdWalletSetupDescription:
    "Налаштування вашого холодного гаманця зазвичай передбачає ініціалізацію пристрою на безпечному офлайн-комп'ютері. Вам потрібно буде створити та безпечно зберігати фразу для відновлення, яка необхідна для доступу до ваших активів у разі втрати пристрою чи його поломки. Детальні інструкції надаються з вашою покупкою для забезпечення безперебійного процесу налаштування.",
  CryptocurrenciesCompatibleWithColdWallet:
    "Які криптовалюти сумісні з вашими холодними гаманцями?",
  CryptocurrenciesCompatibilityDescription:
    "Наші холодні гаманці підтримують широкий спектр криптовалют, включаючи основні, такі як Bitcoin, Ethereum та Litecoin, а також різні альткоїни. Для повного списку підтримуваних валют, будь ласка, відвідайте наш вебсайт або зверніться до документації продукту.",
  HowToSecureColdWallet: "Як забезпечити безпеку мого холодного гаманця?",
  ColdWalletSecurityDescription:
    "Щоб захистити свій холодний гаманець, завжди зберігайте фразу для відновлення в безпечному та приватному місці, ніколи не діліться нею з іншими людьми і розгляньте додаткові заходи безпеки, такі як біометричні замки або захищені контейнери. Регулярне оновлення прошивки гаманця з офіційного вебсайту також допомагає захистити від вразливостей.",
  ColdWalletNotWorking:
    "Що робити, якщо мій холодний гаманець не працює або виникла помилка?",
  ColdWalletErrorDescription:
    "Якщо ви зіткнулися з проблемами з холодним гаманцем, зверніться до розділу усунення неполадок у нашому посібнику користувача. Для більш специфічних проблем зверніться до нашої команди підтримки через наш вебсайт. Переконайтеся, що у вас є інформація про пристрій, щоб прискорити процес підтримки.",
  Community: "Спільнота",
  "Subscribe.title": "Отримувати оновлення продукту",
  "Subscribe.subtitle":
    "Ми відстежуємо криптотренди для вас. Отримуйте оновлення продукту, аналітику ринку та ексклюзивні привілеї — прямо до вашої скриньки.",
  "Subscribe.placeholder": "Введіть вашу електронну пошту",
  "Subscribe.button": "Підписатися на оновлення продукту",
  "Subscribe.input.aria": "Поле введення адреси електронної пошти",
  "Subscribe.success": "Дякуємо за підписку! Перевірте лист із підтвердженням.",
  "Subscribe.error": "Не вдалося оформити підписку. Спробуйте пізніше.",
  "Subscribe.invalid": "Введіть дійсну адресу електронної пошти.",
  "Subscribe.privacy":
    "Вашу адресу електронної пошти використовуватимемо лише для надсилання розсилки та оновлень. Ви можете відписатися будь-коли за посиланням у листі.",
  "Subscribe.learnMore":
    "Дізнайтеся більше про обробку ваших даних і ваші права.",
  "Subscribe.popupCompact.title": "Будьте в курсі",
  "Subscribe.popupCompact.subtitle":
    "Оновлення продукту та поради з безпеки. Без спаму.",
  "Subscribe.popupCompact.button": "Підписатися",
  "Subscribe.popupCompact.privacy":
    "Лише e-mail. Відписатися можна будь-коли.",
  "SubscribeConfirmed.alt.success": "Підписку підтверджено",
  "SubscribeConfirmed.alt.failed": "Не вдалося оформити підписку",
  "SubscribeConfirmed.title.success": "Підписку підтверджено",
  "SubscribeConfirmed.title.failed": "Підписка не вдалася",
  "SubscribeConfirmed.message.success":
    "Дякуємо за підтвердження електронної пошти. Вашу підписку активовано. Лист-привітання надіслано у вашу скриньку.",
  "SubscribeConfirmed.message.failed":
    "Посилання для підтвердження недійсне або строк його дії минув. Поверніться на головну сторінку і спробуйте підписатися ще раз.",
  "SubscribeConfirmed.cta.backHome": "Повернутися на головну",
  "SubscribeConfirmed.note.unsubscribe":
    "Ви можете відписатися будь-коли за посиланням у наших листах.",
  // ===== MarketView i18n =====
  "MarketView.title": "Панель ринку",
  "MarketView.loading": "Завантаження...",
  "MarketView.tab.youtube": "YouTube",
  "MarketView.tab.x": "X (Twitter)",
  "MarketView.tabError.failed": "Не вдалося відрендерити вкладку",
  "MarketView.unknownError": "Невідома помилка",

  // ===== Common i18n =====
  "Common.refresh": "Оновити",
  "Common.toggleSeriesVisibility": "Перемкнути відображення цього ряду",
  "Common.error": "Помилка",
  "Common.dataUpdateTime": "Час оновлення даних",
  "Common.loading": "Завантаження...",
  "Common.noDataSource": "Немає даних (джерело не надано)",

  // ===== Common ranges =====
  "Common.to": "до",
  "Common.clear": "Очистити",
  "Common.range.thisMonth": "Цього місяця",
  "Common.range.lastMonth": "Минулого місяця",
  "Common.range.last2": "Останні 2 місяці",
  "Common.range.last3": "Останні 3 місяці",
  "Common.range.last6": "Останні 6 місяців",
  "Common.range.thisYear": "Цього року",
  "Common.range.all": "Усе",
  "Common.range.custom": "Користувацький",
  "Common.showFilters": "Показати фільтри",
  "Common.hideFilters": "Сховати фільтри",
  "Common.search": "Пошук",
  "Common.priority": "Пріоритет",
  "Common.owner": "Відповідальний",
  "Common.collaborator": "Співвиконавець",

  // ===== YouTubeTab i18n =====
  "YouTubeTab.downloadTitle": "Завантажити backend data/youtube_stats.json",
  "YouTubeTab.downloadJson": "Завантажити youtube_stats.json",
  "YouTubeTab.loading": "Завантаження метрик YouTube...",
  "YouTubeTab.errorHint":
    "Якщо ключ API не налаштовано, задайте YOUTUBE_API_KEY або GOOGLE_API_KEY у backend/.env та перезапустіть бекенд.",
  "YouTubeTab.header.totalViews":
    "Загальна кількість переглядів (багатоканально, одиниця: 10k)",
  "YouTubeTab.header.totalSubscribers":
    "Загальна кількість підписників (багатоканально, одиниця: 10k)",
  "YouTubeTab.dist.views": "Розподіл переглядів (10k)",
  "YouTubeTab.dist.subscribers": "Розподіл підписників (10k)",
  "YouTubeTab.card.location": "Місцезнаходження:",
  "YouTubeTab.card.registeredAt": "Зареєстровано:",
  "YouTubeTab.card.currentSubscribers": "Поточні підписники",
  "YouTubeTab.card.currentVideos": "Поточна кількість відео",
  "YouTubeTab.card.currentTotalViews": "Поточна загальна кількість переглядів",
  "YouTubeTab.card.currentTotalComments":
    "Поточна загальна кількість коментарів",
  "YouTubeTab.chart.totalSubscribers": "Всього підписників",
  "YouTubeTab.chart.totalViews": "Всього переглядів",
  "YouTubeTab.chart.totalComments": "Всього коментарів",
  "YouTubeTab.chart.totalVideos": "Всього відео",

  // ===== XTab i18n =====
  "XTab.downloadTitle": "Завантажити backend data/x_stats.json",
  "XTab.downloadJson": "Завантажити x_stats.json",
  "XTab.loading": "Завантаження метрик X...",
  "XTab.errorHint":
    "Якщо токен не налаштовано, задайте X_BEARER_TOKEN або TWITTER_BEARER_TOKEN у backend/.env та перезапустіть бекенд.",
  "XTab.header.totalFollowers":
    "Загальна кількість підписників (багатоканально, одиниця: 10k)",
  "XTab.header.totalEngagement":
    "Загальна взаємодія (останні 5 дописів: вподобання + ретвіти + відповіді + цитати, одиниця: 10k)",
  "XTab.dist.followers": "Розподіл підписників (10k)",
  "XTab.dist.engagement":
    "Розподіл взаємодії (останні 5 дописів: вподобання + ретвіти + відповіді + цитати, одиниця: 10k)",
  "XTab.card.currentFollowers": "Поточні підписники",
  "XTab.card.currentFollowing": "Поточні підписки",
  "XTab.card.currentTweets": "Поточна кількість твітів",
  "XTab.card.recentLikes": "Останні вподобання (останні 5 дописів)",
  "XTab.card.recentRetweets": "Останні ретвіти (останні 5 дописів)",
  "XTab.card.recentReplies": "Останні відповіді (останні 5 дописів)",
  "XTab.card.recentQuotes":
    "Останні перегляди (рівень контенту, останні 5 дописів)",
  "XTab.card.listed": "Кількість у списках (рівень каналу)",
  "XTab.smallChart.followers": "Підписники",
  "XTab.smallChart.tweets": "Твіти",
  "XTab.smallChart.likes": "Останні вподобання",
  "XTab.smallChart.retweets": "Останні ретвіти",
  "XTab.smallChart.replies": "Останні відповіді",
  "XTab.smallChart.quotes": "Останні перегляди (рівень контенту)",
  "XTab.smallChart.following": "Підписки",
  "XTab.smallChart.listed": "У списках",

  // ===== Analytics i18n =====
  "Analytics.filter.monthLabel": "Фільтрувати за місяцем створення:",
  "Analytics.dashboardTitle": "Панель здоров'я проєкту",
  "Analytics.metric.completionRate": "Рівень завершення",
  "Analytics.metric.teamVelocity": "Швидкість команди",
  "Analytics.metric.blockerRatio": "Частка блокерів",
  "Analytics.metric.workloadBalance": "Баланс навантаження",
  "Analytics.charts.statusDistribution": "Розподіл статусів",
  "Analytics.charts.statusByMonthPercent": "Статуси за місяцями (відсоток)",
  "Analytics.charts.priorityDistribution": "Розподіл пріоритетів",
  "Analytics.charts.priorityByMonthPercent":
    "Пріоритети за місяцями (відсоток)",
  "Analytics.charts.functionTypeDistribution": "Розподіл типів функцій",
  "Analytics.charts.functionTypeByMonthPercent":
    "Типи функцій за місяцями (відсоток)",
  "Analytics.blocker.ownerPie":
    "Заблоковані задачі · Розподіл відповідальних (пончик)",
  "Analytics.blocker.ownerByMonth":
    "Заблоковані задачі · Відповідальні за місяцями (відсоток)",
  "Analytics.bug.ownerPie":
    "Задачі з багами · Розподіл відповідальних (пончик)",
  "Analytics.bug.ownerByMonth":
    "Задачі з багами · Відповідальні за місяцями (відсоток)",
  "Analytics.ownerWorkloadDistribution":
    "Розподіл робочого навантаження команди",
  "Analytics.mode.priority": "Розподіл пріоритетів",
  "Analytics.mode.status": "Розподіл статусів",
  "Analytics.mode.type": "Розподіл типів",
  "Analytics.blocker.attentionNeeded": "Задачі, що потребують негайної уваги",
  "Analytics.common.status": "Статус",
  "Analytics.common.owner": "Відповідальний",
  "Analytics.insights.sectionTitle": "Інсайти проєкту та пропозиції",
  "Analytics.insights.efficiency.title": "Пропозиції з підвищення ефективності",
  "Analytics.insights.efficiency.completionRate":
    "• Поточний рівень завершення {{rate}}%, слідкуйте за блокерами",
  "Analytics.insights.efficiency.avgVelocity":
    "• Середня швидкість команди — {{velocity}} завдань/особу",
  "Analytics.insights.efficiency.workloadBalance":
    "• Баланс навантаження — {{balance}}%",
  "Analytics.insights.risk.title": "Попередження про ризики",
  "Analytics.insights.risk.blockerRatio": "• Частка блокерів {{ratio}}%",
  "Analytics.insights.risk.p0Ratio": "• Частка завдань рівня P0 {{ratio}}%",
  "Analytics.insights.risk.suggestion":
    "• Спочатку вирішуйте завдання з високим пріоритетом",

  // ===== Kanban i18n =====
  "Kanban.title": "Канбан",
  "Kanban.totalIssues": "Всього {{count}} завдань",
  "Kanban.searchPlaceholder":
    "Пошук за назвою, номером завдання, відповідальним або співвиконавцями...",
  "Kanban.status.backlog": "Беклог",
  "Kanban.status.inProgress": "У роботі",
  "Kanban.status.blocked": "Заблоковано / Очікує підтвердження",
  "Kanban.status.reviewTest": "Огляд / Тест",
  "Kanban.status.docs": "Docs",

  // ===== List i18n =====
  "List.title": "Список завдань",
  "List.totalIssues": "Всього {{count}} завдань",
  "List.viewDetails": "Переглянути деталі",
  "List.openInNewWindow": "Відкрити у новому вікні",
  "List.empty.title": "Немає завдань",
  "List.empty.subtitle":
    "Створіть перше завдання, щоб розпочати робочий процес",

  // ===== Assets Register i18n =====
  "Assets.title": "Реєстр активів",
  "Assets.totalSets": "Загальна кількість наборів",
  "Assets.table.employee": "Співробітник",
  "Assets.table.setCount": "Набори",
  "Assets.table.model": "Модель",
  "Assets.total": "Разом",

  // ===== LukkeyIssues i18n =====
  "LukkeyIssues.pageTitle": "Відстеження проєктних завдань",
  "LukkeyIssues.goToDemo": "Перейти на сторінку демо",
  "LukkeyIssues.githubProject": "Проєкт GitHub ↗",
  "LukkeyIssues.githubManageIssues":
    "Керувати Issues безпосередньо на GitHub ↗",
  "LukkeyIssues.financeModel": "Фінансова модель",
  "LukkeyIssues.productCoreIssues": "Ключові проблеми продукту",
  "LukkeyIssues.stats.totalIssues": "📊 Всього завдань",
  "LukkeyIssues.stats.completed": "✅ Завершено",
  "LukkeyIssues.stats.inProgress": "🔄 У роботі",
  "LukkeyIssues.stats.pending": "⏳ Очікує",
  "LukkeyIssues.stats.blocked": "🚫 Заблоковано",
  "LukkeyIssues.stats.docs": "📚 Документи",
  "LukkeyIssues.tabs.kanban": "Канбан",
  "LukkeyIssues.tabs.analytics": "Аналітика",
  "LukkeyIssues.tabs.market": "Панель ринку",
  "LukkeyIssues.tabs.assets": "Реєстр активів",
  "LukkeyIssues.shareToChatGPT": "Відкрити LUKKEY.json у ChatGPT", // ===== PrivacyPolicy i18n =====
  "PrivacyPolicy.title": "Політика конфіденційності LUKKEY",
  "PrivacyPolicy.intro.p1":
    "У LUKKEY ми вважаємо, що найнадійніша приватність — це та, яка завжди повністю перебуває в руках самого користувача.",
  "PrivacyPolicy.intro.p2":
    "Тому, незалежно від того, чи ви користуєтеся апаратним холодним гаманцем LUKKEY, чи мобільним застосунком LUKKEY (App), ми суворо дотримуємося непорушного принципу:",
  "PrivacyPolicy.intro.p3_strong":
    "Якщо користувач явно не надав дозвіл, ми не збираємо, не зберігаємо та не завантажуємо жодної інформації про користувача.",
  "PrivacyPolicy.intro.p3_tail":
    "Усі дані, пов’язані з використанням, зберігаються лише локально на пристрої користувача і ніколи не передаються ані до LUKKEY, ані на будь-який сервер.",
  "PrivacyPolicy.intro.p4":
    "Ця Політика конфіденційності пояснює, як ми дотримуємося цього принципу.",

  "PrivacyPolicy.s1.title": "1. Сфера застосування",
  "PrivacyPolicy.s1.appliesTo":
    "Ця Політика конфіденційності застосовується до:",
  "PrivacyPolicy.s1.item.hardware": "Апаратний холодний гаманець LUKKEY",
  "PrivacyPolicy.s1.item.app": "Мобільний застосунок LUKKEY (App)",
  "PrivacyPolicy.s1.principle":
    "Обидва дотримуються єдиного принципу приватності: «нуль збору, нуль завантаження, тільки локальне зберігання».",

  "PrivacyPolicy.s2.title": "2. Інформація, яку МИ НЕ збираємо",
  "PrivacyPolicy.s2.desc":
    "Щоб захистити вашу приватність, ми прямо зобов’язуємося не збирати, не завантажувати та не зберігати жодної користувацької інформації, включно з (але не обмежуючись):",
  "PrivacyPolicy.s2.li.identity":
    "Ідентифікаційні дані: ім’я, номер телефону, адреса електронної пошти, поштова адреса",
  "PrivacyPolicy.s2.li.walletSensitive":
    "Конфіденційні дані гаманця: приватні ключі, мнемонічні фрази, файли keystore, паролі гаманця",
  "PrivacyPolicy.s2.li.blockchain":
    "Дані блокчейну: адреси гаманців, історія транзакцій, інформація про активи",
  "PrivacyPolicy.s2.li.behavior":
    "Поведінкові дані: журнали застосунку, записи кліків, поведінкова аналітика",
  "PrivacyPolicy.s2.li.technical":
    "Технічна інформація: ідентифікатори пристрою, геолокація, IP‑адреса",
  "PrivacyPolicy.s2.inShort.title": "Коротко:",
  "PrivacyPolicy.s2.inShort.desc":
    "Усе, що ви бачите на апаратному пристрої та в Застосунку, існує лише на вашому пристрої. LUKKEY не має доступу до цих даних.",

  "PrivacyPolicy.s3.title":
    "3. Дизайн приватності та безпеки апаратного холодного гаманця",
  "PrivacyPolicy.s3.desc":
    "Апаратний холодний гаманець LUKKEY забезпечує повністю офлайн та безпечне середовище. Ключові можливості:",
  "PrivacyPolicy.s3.h1.title": "1. Апаратура захисту військового рівня",
  "PrivacyPolicy.s3.h1.l1": "Secure Element з сертифікацією EAL6+",
  "PrivacyPolicy.s3.h1.l2": "Повністю шифроване спілкування на рівні апаратури",
  "PrivacyPolicy.s3.h2.title": "2. Функції безпеки",
  "PrivacyPolicy.s3.h2.l1": "Автентифікація за відбитком пальця",
  "PrivacyPolicy.s3.h2.l2": "Режим приватності",
  "PrivacyPolicy.s3.h2.l3": "Ізольоване керування кількома гаманцями",
  "PrivacyPolicy.s3.h3.title": "3. Повна ізоляція",
  "PrivacyPolicy.s3.h3.l1": "Відсутність підключення до Інтернету",
  "PrivacyPolicy.s3.h3.l2": "Відсутність підключення кабелем передачі даних",
  "PrivacyPolicy.s3.h4.title": "4. Стійкість до втручань із самознищенням",
  "PrivacyPolicy.s3.h4.desc":
    "Якщо пристрій розібрано, пошкоджено або піддано аномальному втручанню, Secure Element автоматично знищує чутливі дані, щоб унеможливити витяг приватних ключів.",
  "PrivacyPolicy.s3.h5.title":
    "5. Чутливі операції виконуються лише всередині Secure Element",
  "PrivacyPolicy.s3.h5.l1": "Створення гаманця",
  "PrivacyPolicy.s3.h5.l2": "Імпорт гаманця",
  "PrivacyPolicy.s3.h5.l3": "Підписання транзакцій",
  "PrivacyPolicy.s3.h5.note":
    "Усі чутливі процеси відбуваються на 100% усередині Secure Element та ніколи не розкриваються жодному ненадійному чипу чи області зберігання.",
  "PrivacyPolicy.s3.h6.title": "6. Жодних чутливих даних поза Secure Element",
  "PrivacyPolicy.s3.h6.desc":
    "У несекретних зонах зберігання пристрою не зберігаються приватні ключі, мнемонічні фрази чи будь-яка інша чутлива інформація.",

  "PrivacyPolicy.s4.title":
    "4. Дизайн приватності та безпеки Застосунку LUKKEY",
  "PrivacyPolicy.s4.desc":
    "Застосунок LUKKEY зосереджується лише на відображенні інформації та наданні сповіщень. Він не обробляє чутливі дані гаманця.",
  "PrivacyPolicy.s4.n1.title": "1. Чого Застосунок НЕ робить",
  "PrivacyPolicy.s4.n1.l1": "Не створює блокчейн‑гаманці",
  "PrivacyPolicy.s4.n1.l2": "Не імпортує блокчейн‑гаманці",
  "PrivacyPolicy.s4.n1.l3": "Не зберігає приватні ключі або мнемонічні фрази",
  "PrivacyPolicy.s4.n1.l4": "Не завантажує жодних даних користувача",
  "PrivacyPolicy.s4.n1.l5":
    "Не виконує поведінкову аналітику, рекламне відстеження чи збір даних",
  "PrivacyPolicy.s4.n2.title": "2. Що Застосунок РОБИТЬ",
  "PrivacyPolicy.s4.n2.l1":
    "Відображає публічно доступну інформацію, авторизовану апаратним пристроєм",
  "PrivacyPolicy.s4.n2.l2":
    "Надає панель налаштувань приватності з поясненням призначення кожного дозволу",
  "PrivacyPolicy.s4.n2.l3":
    "Надає користувачеві повний контроль для вмикання/вимикання дозволів у будь-який час",
  "PrivacyPolicy.s4.n2.l4": "Пропонує маскування чутливої інформації",
  "PrivacyPolicy.s4.n2.l5": "Вимикає знімок екрана/запис у певних розділах",
  "PrivacyPolicy.s4.n2.l6":
    "Виявляє підозрілі блокчейн‑адреси шляхом локального зіставлення",
  "PrivacyPolicy.s4.n2.l7":
    "Регулярно оновлює небезпечні URL‑адреси, контракти та адреси",
  "PrivacyPolicy.s4.n2.l8":
    "Потік оновлень — односпрямований: лише сервер → пристрій",
  "PrivacyPolicy.s4.n2.l9":
    "Під час оновлень жодні дані користувача ніколи не надсилаються назад",
  "PrivacyPolicy.s4.n3.title": "3. Локальне зберігання",
  "PrivacyPolicy.s4.n3.p1":
    "Застосунок зберігає локально лише неконфіденційні дані, такі як налаштування інтерфейсу, мова та тема. Ці дані:",
  "PrivacyPolicy.s4.n3.l1": "не завантажуються",
  "PrivacyPolicy.s4.n3.l2": "не синхронізуються",
  "PrivacyPolicy.s4.n3.l3": "недоступні для LUKKEY",

  "PrivacyPolicy.s5.title": "5. Передача даних і політика серверів",
  "PrivacyPolicy.s5.l1":
    "Сервери LUKKEY не зберігають жодної інформації про користувачів",
  "PrivacyPolicy.s5.l2":
    "Спілкування Застосунку з сервером обмежується оновленнями бази даних і версій",
  "PrivacyPolicy.s5.l3":
    "Під час спілкування не передаються жодні дані користувача",
  "PrivacyPolicy.s5.l4":
    "Навіть у разі компрометації сервера користувацькі дані не можуть бути розкриті, оскільки ми їх ніколи не отримуємо",

  "PrivacyPolicy.s6.title": "6. Прозорість з відкритим кодом",
  "PrivacyPolicy.s6.l1": "Вихідний код Застосунку LUKKEY є відкритим",
  "PrivacyPolicy.s6.l2":
    "Вбудоване програмне забезпечення апаратного забезпечення LUKKEY є відкритим",
  "PrivacyPolicy.s6.l3": "Повністю доступне на GitHub для будь‑кого",
  "PrivacyPolicy.s6.p": "Прозорість — складова безпеки.",

  "PrivacyPolicy.s7.title": "7. Повний контроль користувача",
  "PrivacyPolicy.s7.p":
    "Попри те, що ми не збираємо інформацію про користувачів, користувачі зберігають повний контроль над своїми пристроями:",
  "PrivacyPolicy.s7.l1": "Ви можете будь‑коли вимкнути дозволи Застосунку",
  "PrivacyPolicy.s7.l2":
    "Ви можете видалити Застосунок, щоб прибрати всі локальні дані застосунку",
  "PrivacyPolicy.s7.l3":
    "Ви можете скинути апаратний пристрій, аби назавжди видалити приватні ключі та дані гаманця",
  "PrivacyPolicy.s7.p2": "LUKKEY не втручається і не може втручатися в ці дії.",

  "PrivacyPolicy.s8.title": "8. Зв’яжіться з нами",
  "PrivacyPolicy.s8.p":
    "Якщо у вас є запитання щодо цієї Політики конфіденційності, зв’яжіться з нами:",
  "PrivacyPolicy.s8.email": "Електронна пошта: info@lukkey.com",
  "PrivacyPolicy.s8.address":
    "Адреса: Головний офіс LUKKEY, Baarerstrasse 25, 6300 Цуг, Швейцарія",

  // ===== EmailOtpProtectedRoute i18n =====
  "EmailOtp.checking": "Перевірка...",
  "EmailOtp.title":
    "Обмежений доступ: введіть ім’я та email, щоб отримати код входу",
  "EmailOtp.nameLabel": "Ім’я",
  "EmailOtp.namePlaceholder": "Введіть ваше ім’я",
  "EmailOtp.emailLabel": "Електронна пошта",
  "EmailOtp.emailPlaceholder": "name@example.com",
  "EmailOtp.sendCode": "Надіслати код",
  "EmailOtp.resendCode": "Надіслати код ще раз",
  "EmailOtp.resendWithCountdown": "Надіслати повторно через {{s}} с",
  "EmailOtp.codeValidityHint":
    "Код дійсний 5 хвилин. Не діліться ним із кимось.",
  "EmailOtp.codeLabel": "Код підтвердження з email",
  "EmailOtp.codePlaceholder": "Введіть отриманий код",
  "EmailOtp.signIn": "Увійти",
  "EmailOtp.message.codeSent": "Код підтвердження надіслано на вашу пошту.",
  "EmailOtp.error.nameRequired": "Ім’я обов’язкове",
  "EmailOtp.error.invalidEmail": "Некоректний email",
  "EmailOtp.error.sendFailed": "Не вдалося надіслати код",
  "EmailOtp.error.codeRequired": "Введіть код підтвердження",
  "EmailOtp.error.verificationFailed": "Не вдалося підтвердити код",
  // ===== Academy i18n =====
  "Academy.hero.alert": "Нагадування з безпеки: завжди перевіряйте посилання і ніколи не діліться фразою відновлення.",
  "Academy.hero.title1": "LUKKEY",
  "Academy.hero.title2": "Академія",
  "Academy.hero.subtitle": "Практичні посібники з криптобезпеки, self‑custody та використання холодного гаманця LUKKEY.",
  "Academy.search.placeholder": "Пошук навчальних матеріалів, кращих практик і FAQ…",
  "Academy.search.hint": "[ENTER]",
  "Academy.card.type.article": "СТАТТЯ",
  "Academy.list.title": "Останні посібники",
  "Academy.list.viewAll": "ПЕРЕГЛЯНУТИ ВСЕ",
  "Academy.list.empty": "Немає результатів. Спробуйте інше ключове слово.",
  "Academy.image.placeholder": "ЗОБР.",

  // ===== AcademyArticle i18n =====
  "AcademyArticle.back": "Повернутися до Академії",
  "AcademyArticle.notFound": "Статтю не знайдено",
  "AcademyArticle.author": "Автор",
  "AcademyArticle.unscheduled": "Немає запланованого часу публікації",
  "home.hero.reserveCtaLabel": "Ранній доступ — 1 $",
  "home.hero.reserveCtaNote": "Повне відшкодування. Без зобов’язання купівлі."
};
export default translation;
